import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.menuItems),function(item){return [_c(VListItem,{key:item.text,attrs:{"to":item.to,"exact":item.exact}},[_c(VListItemAction,[(item.icon)?_c(VIcon,[_vm._v("\n          "+_vm._s(item.icon)+"\n        ")]):_vm._e()],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])],1)],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }